export function completedTasks(tasks) {
    return tasks.filter(task => task.isCompleted)
}
